import { Logo } from "@/components/Logo/Logo";
import { Route } from "@/paths";
import { BoxComponentProps, Group, Text, TextProps } from "@mantine/core";
import { ReactNode } from "react";
import { BiChevronRight } from "react-icons/bi";
import { Link, To } from "react-router-dom";

export const defaultHeaderHeight = 42;

export const Breadcrumbs = ({ children }: { children: ReactNode }) => {
  return (
    <Group px={"xs"} h={"100%"} w={"100%"} align="center" gap={6}>
      <Logo w={56} variant="dark" to={Route.DealTracker} />
      <BreadcrumbSeperator />
      {children}
    </Group>
  );
};

export const BreadcrumbTitle = ({
  children,
  to,
  ...props
}: {
  children: ReactNode;
  to?: To;
} & TextProps) => {
  return (
    <Text
      lh={1}
      fw={600}
      fz={"md"}
      {...(to ? { component: Link, to } : { to: "" })}
      {...props}
    >
      {children}
    </Text>
  );
};

export const BreadcrumbSeperator = (props: BoxComponentProps) => {
  return (
    <Group {...props}>
      <BiChevronRight />
    </Group>
  );
};
